import http from "@/settings/apiSettings"
import ODataStore from "devextreme/data/odata/store"
import AppSettings from "@/settings/appSettings"

class PORTAL_TicketsService {
  getODataStore() {
    return new ODataStore({
      url: AppSettings.API_Url_PortalHROdata + "PORTAL_Tickets",
      key: "ID",
      version: 4,
      beforeSend: (e: any) => {
        e.headers = { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") };
      }
    });
  }

  add(data: any): Promise<any> {
    return http.clientPortalHROdata.post("/PORTAL_Tickets", data, {
      headers: { Authorization: "Bearer " + localStorage.getItem("ERA_Jwt") }
    });
  }
}

export default new PORTAL_TicketsService();
